import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { axiosInstance as axios } from '../../utils/axios';
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  meta: null,
  params: {
    page: 1,
    active: true,
    deleted: false,
  },
  record: null,
};

const slice = createSlice({
  name: 'hrVacationType',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getVacationTypesSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload.results;
      state.meta = action.payload.meta;
      state.error = false;
    },
    getVacationTypeSuccess(state, action) {
      state.isLoading = false;
      state.record = action.payload;
      state.error = false;
    },
    createVacationTypeSuccess(state, action) {
      state.isLoading = false;
      state.data = [...state.data, action.payload];
      state.error = false;
    },
    updateVacationTypeSuccess(state, action) {
      state.record = action.payload;
      state.isLoading = false;
      state.data = map(state.data, (_record) => (_record.id === action.payload.id ? action.payload : _record));
      state.params = { ...state.params };
      state.error = false;
    },
    deleteVacationTypeSuccess(state, action) {
      state.isLoading = false;
      state.data = filter(state.data, (r) => r.id !== action.payload.id);
      state.error = false;
    },
    setParams(state, action) {
      state.params = action.payload;
    },
    refreshParams(state) {
      state.params = { ...state.params };
    },
  },
});

export default slice.reducer;
export const { setParams, refreshParams } = slice.actions;

// ----------------------------------------------------------------------

export function getVacationTypes(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/hr/vacation-type/', { params });
      dispatch(slice.actions.getVacationTypesSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return error;
    }
  };
}

export function getVacationType(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/hr/vacation-type/${id}/`);
      dispatch(slice.actions.getVacationTypeSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createVacationType(record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/hr/vacation-type/', record);
      dispatch(slice.actions.createVacationTypeSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function updateVacationType(id, record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`/hr/vacation-type/${id}/`, record);
      dispatch(slice.actions.updateVacationTypeSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function deleteVacationType(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`/hr/vacation-type/${id}/`);
      dispatch(slice.actions.deleteVacationTypeSuccess({ id }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
